import React, { useCallback } from 'react';
import useAPI from '../../../services/useAPI';
import { useTranslation } from '../../../localization/useTranslation';
import ConfirmDeleteModal from '../../Modals/ConfirmDeleteModal';
import { providerClientKeys } from './queries';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import createMutationRequest from 'utils/createMutationRequest';
import _ from 'lodash';

const DeleteProviderClient = ({ providerId, confirmDeleteItem, onDelete, cancelDelete }) => {
  const T = useTranslation();
  const api = useAPI();
  const queryClient = useQueryClient();

  const deleteProviderClient = useMutation(createMutationRequest(api.core.deleteProviderClient), {
    onMutate: (client) => {
      const oldClients = queryClient.getQueryData(providerClientKeys.clients(providerId));
      queryClient.setQueryData(providerClientKeys.clients(providerId), (oldClients) => {
        return _.reject(oldClients, { id: client.id });
      });
      return oldClients;
    },
    onSuccess: () => {
      onDelete(confirmDeleteItem);
      queryClient.invalidateQueries(providerClientKeys.clients(providerId));
    },
    onError: (error, unusedVariables, context) => {
      console.error(error);
      queryClient.setQueryData(providerClientKeys.clients(providerId), context);
    }
  });

  const onConfirmedDelete = useCallback(({ providerId, providerClient }) => {
    deleteProviderClient.mutate({ providerId: providerId, providerClientId: providerClient.id });
  }, [deleteProviderClient]);

  return (
    <>
      <ConfirmDeleteModal
        isLoading={deleteProviderClient.isLoading}
        onConfirm={onConfirmedDelete}
        item={confirmDeleteItem}
        itemName={confirmDeleteItem?.providerClient?.displayName ?? T.common.noname}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default DeleteProviderClient;
